import PageHero from '../components/PageHero';
import { interimDetails } from '../data';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Interim() {
  return (
    <main className="bg-white">
      <SEO 
        title="Interim Management | Midlertidig Økonomi- & Jurahjælp – FINANJU"
        description="Mangler du midlertidig ledelse eller specialistkompetencer? FINANJU tilbyder interim CFO, økonomistyring og juridisk assistance med kort varsel."
        path="/interim-opgaver"
      />
      <PageHero
        title="Interim Opgaver"
        subtitle="Midlertidig assistance med varig effekt. Vi træder til, når I har brug for ekstra ressourcer eller specialiseret kompetence."
        breadcrumbs={[{ name: 'Interim opgaver', href: '/interim-opgaver' }]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Når behovet for kompetence er akut</h2>
              <p className="text-lg text-slate-500 leading-relaxed mb-6">
                Uanset om I står over for en pludselig opsigelse, spidsbelastning i forbindelse med årsafslutning, eller et stort projekt der kræver ekstra hænder, kan FINANJU træde til med kort varsel.
              </p>
              <p className="text-lg text-slate-500 leading-relaxed mb-10">
                Vi tilbyder interim management inden for både økonomi og jura. Vores konsulenter er selvkørende fra første dag og sikrer, at jeres drift fortsætter ufortrødent.
              </p>
              <div className="space-y-6">
                {interimDetails.map((detail, idx) => (
                  <div key={idx} className="flex gap-4">
                    <div className="mt-1">
                      <CheckCircle2 className="h-6 w-6 text-[#876a57]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-900 mb-1">{detail.title}</h3>
                      <p className="text-slate-500">{detail.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-16 lg:mt-0 relative">
              <div className="aspect-[4/3] rounded-sm overflow-hidden bg-slate-100 shadow-2xl">
                <img
                  src="/images/office-desk-with-plant-and-art.png"
                  alt="Minimalistisk kontormiljø med plante og kontorartikler"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Dark CTA Box matching Full Service layout */}
          <div className="bg-slate-900 rounded-sm p-12 lg:p-16 text-center shadow-lg relative overflow-hidden">
             <div className="absolute inset-0 z-0">
                <img
                  src="/images/consultation.png"
                  alt="Background"
                  className="w-full h-full object-cover opacity-10 grayscale mix-blend-multiply"
                />
             </div>
             <div className="relative z-10">
                <h3 className="text-2xl font-bold text-white mb-6">Få skræddersyet en løsning</h3>
                <p className="text-slate-300 mb-10 max-w-2xl mx-auto">
                  Lad os tage en uforpligtende dialog om jeres behov for midlertidig assistance og ekstra ressourcer.
                </p>
                <Link to="/kontakt?emne=interim" className="cta-button">
                  Kontakt FINANJU
                </Link>
             </div>
          </div>
        </div>
      </section>
    </main>
  );
}
